export class ServiceRole {
    code = null;
    name = null;
    description = null;
}